export const fetchActivityLogsExport = (
  daysBack: number,
  logType: 'audit' | 'system',
  accessToken?: string,
): Promise<Response> => {
  const headers: Record<string, string> = {
    Accept: 'text/csv',
  };
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  return fetch(
    `${window.VITE_API_BASE_URL}/account/activity-logs/${logType}/export.csv?days_back=${daysBack}`,
    {
      method: 'GET',
      headers,
    },
  );
};
